import { render, staticRenderFns } from "./teachingCenter.vue?vue&type=template&id=42b00ba5&scoped=true"
import script from "./teachingCenter.vue?vue&type=script&lang=js"
export * from "./teachingCenter.vue?vue&type=script&lang=js"
import style0 from "./teachingCenter.vue?vue&type=style&index=0&id=42b00ba5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b00ba5",
  null
  
)

export default component.exports